import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  assetId: string;
  name: string;
};

const [useCreateDirectLink, createDirectLink] = createAsyncAction(
  "assets/createDirectLink",
  async ({ assetId, name }: Args) => {
    const res = await API.call<{ directLink: number }>({
      endpoint: `assets/${assetId}/direct_links`,
      method: "POST",
      data: {
        name,
      },
    });
    return { ...res, result: res.result.directLink };
  }
);
export default useCreateDirectLink;
export { createDirectLink };
